function Header() {

    return (
        <header id="_main_header">
            <div id="_mh_title">R2MAPS</div>
            <div id="_mh_fullname">| Rainfall Risk Monitoring And Prediction System</div>
        </header>
    )
}

export default Header;